<template>
    <div ref="container" class="section-item-group" :style="groupStyle">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'SySectionItemGroup',
    provide() {
        return {
            sectionGroup: this
        };
    },
    inject: ['section'],
    data() {
        return {
            // 子项列表
            itemList: []
        };
    },
    computed: {
        /**
         * label是否在顶部
         */
        isTop() {
            return this.section.labelPosition === 'top';
        },
        /**
         * 计算分组宽度
         */
        itemWidth() {
            // 注意:分组宽度不等于子项的最大宽度值
            return this.isTop ? Math.max(this.labelWidth, this.contentWidth) : this.labelWidth + this.contentWidth;
        },
        /**
         * 计算子项最大标签宽度
         */
        labelWidth() {
            let res = 0;
            this.itemList.forEach(item => {
                res = Math.max(res, item.labelWidth);
            });
            return res;
        },
        /**
         * 计算子项最大内容宽度
         */
        contentWidth() {
            let res = 0;
            this.itemList.forEach(item => {
                res = Math.max(res, item.contentWidth);
            });
            return res;
        },
        /**
         * item样式对象
         */
        groupStyle() {
            return {
                width: this.isAutoWidth ? 'auto' : this.section.itemWidth,
                marginRight: `${this.colGap}px`,
                marginBottom: `${this.rowGap}px`
            };
        }
    },
    /**
     * 组件渲染完成方法
     */
    mounted() {
        this.section.addItem(this);
    },
    /**
     * 组件销毁方法
     */
    destroyed() {
        this.section.removeItem(this);
    },
    methods: {
        /**
         * 添加子项
         * @param item
         */
        addItem(item) {
            this.itemList.push(item);
        },
        /**
         * 删除子项
         * @param target
         */
        removeItem(target) {
            const index = this.itemList.findIndex(item => item.key === target);
            this.itemList.splice(index, 1);
        },
        /**
         * 设置子项间距
         * @param gap
         */
        setColGap(gap) {
            if (!this.itemList.length) {
                return;
            }

            this.itemList.forEach(item => {
                item.setColGap(gap);
            });
        },
        /**
         * 设置子项行间距
         * @param gap
         */
        setRowGap(gap) {
            if (!this.itemList.length) {
                return;
            }

            this.itemList.forEach(item => {
                item.setRowGap(gap);
            });
        }
    }
};
</script>
